export type SpreadKey = 'one-card' | 'three-card' | 'celtic-cross';

/** Responsive MUI Grid column sizes used when laying out the revealed cards. */
export interface SpreadGridSize {
  xs: number;
  sm: number;
  md: number;
  lg?: number;
}

export interface SpreadLayout {
  /** Column span of each revealed card per breakpoint. */
  gridSize: SpreadGridSize;
  /** Whether the revealed cards should be centered rather than left-aligned. */
  centered: boolean;
}

export interface Spread {
  key: SpreadKey;
  /** Short display name (cards, buttons, aria-labels). */
  name: string;
  /** Longer label used in the spread selector and the reading title. */
  label: string;
  description: string;
  size: number;
  positions: readonly string[];
  layout: SpreadLayout;
}

export const SPREADS: Record<SpreadKey, Spread> = {
  'one-card': {
    key: 'one-card',
    name: 'Single Card',
    label: 'Single Card',
    description: 'A quick insight into your question or current situation.',
    size: 1,
    positions: ['Insight'],
    layout: { gridSize: { xs: 12, sm: 8, md: 6, lg: 4 }, centered: true },
  },
  'three-card': {
    key: 'three-card',
    name: 'Three Card',
    label: 'Three Card (Past · Present · Future)',
    description: 'Explore past influences, present circumstances, and future outcomes.',
    size: 3,
    positions: ['Past', 'Present', 'Future'],
    layout: { gridSize: { xs: 12, sm: 6, md: 4 }, centered: false },
  },
  'celtic-cross': {
    key: 'celtic-cross',
    name: 'Celtic Cross',
    label: 'Celtic Cross',
    description: 'A comprehensive reading covering ten key aspects of your situation.',
    size: 10,
    positions: [
      'Present',
      'Challenge',
      'Past',
      'Future',
      'Above',
      'Below',
      'Advice',
      'External',
      'Hopes & Fears',
      'Outcome',
    ],
    layout: { gridSize: { xs: 6, sm: 4, md: 3 }, centered: false },
  },
};

export const SPREAD_LIST: readonly Spread[] = Object.values(SPREADS);

export function isSpreadKey(value: string | null | undefined): value is SpreadKey {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(SPREADS, value);
}

export const DEFAULT_SPREAD: SpreadKey = 'three-card';
